export default {
  methods: {
    $_tapEndLabel(endLabel) {
      this.$emit('tapEndLabel', this.result, this.index, endLabel)
    }
  }
}
